import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { throttle } from 'lodash';

// Store stuff
import reducers from 'reducers';
import sagas from 'sagas';
import { saveState, loadState } from './stateStorage';

const sagaMiddleware = createSagaMiddleware();
let persistedState = loadState();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create our store
let store = createStore(
  reducers,
  persistedState,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

function getPersistedStateShape(state) {
  let saved = {
    auth: state.auth,
    entities: {
      results: state.entities.results,
      users: state.entities.users,
    },
  };
  return saved;
}

// Store parts of our state in localStorage to persist across refresh.
store.subscribe(
  throttle(
    () => {
      const state = store.getState();
      saveState(getPersistedStateShape(state));
    },
    1000,
    { leading: true }
  )
);

// Run our sagas (so they pick up on the relevant actions)
sagaMiddleware.run(sagas);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js